/**
 * Button module implementation.
 *
 * @author Daniel Koch (https://danielkoch.de)
 * @namespace Tc.Module
 * @class Button
 * @extends Tc.Module
 */
T.Module.Button = T.createModule({
	_attributes: {
		href: 'data-js-button-href',
	},
	_selectors: {},
	_eventNames: {
		CLICK: 'click',
	},
	_stateClasses: {},

	start(resolve) {
		this.$ctx = $(this._ctx);
		this.hasHref = this.$ctx.attr(this._attributes.href);

		if (this.hasHref) {
			this.$ctx.on(this._eventNames.CLICK, this.onLinkSubmit.bind(this));
		}

		resolve();
	},

	sync() {
		// Called when start() method of all registered modules was called.
	},

	onLinkSubmit() {
		const { host, protocol } = window.location,
			needsTrailingSlash = this.hasHref.substr(0, 1) !== '/',
			newUrl = new URL(this.hasHref, `${protocol}//${host}${needsTrailingSlash ? '/' : ''}`);

		window.location.assign(newUrl);
	},
});

export default T.Module.Button;
